import React from 'react';
import { bool } from 'prop-types';
import { Col, Image } from '@thd-olt-component-react/core-ui';
import { GREEN_DELIVERY_TRUCK_ICON } from './constants';
import './DeliveryMessage.style.scss';

export const DeliveryMessage = React.memo(({ freeDelivery }) => {

  return (
    <>
      <Col className="fbt-appliance-delivery-message">
        {freeDelivery
          ? (
            <>
              <span className="fbt-appliance-delivery-message__text">
                <Image src={GREEN_DELIVERY_TRUCK_ICON} alt="Green Delivery Truck Icon" lazy />
                <span className="u__text--success"> FREE Home Delivery</span>
              </span>
            </>
          )
          : (
            <span className="fbt-appliance-delivery-message__title--below-threshold u__text--success">
              Free delivery on appliance purchases of $396 and up
            </span>
          )}
      </Col>
    </>
  );
});

DeliveryMessage.propTypes = {
  freeDelivery: bool.isRequired
};
